import { styled } from 'linaria/react';

export const StyledScaler = styled.div<{ scaleFactor?: number; maxHeight?: number; isMine: boolean }>`
  max-height: ${({ maxHeight }) => (maxHeight ? `${maxHeight}px` : 'unset')};
  will-change: max-height;
  transform: ${({ scaleFactor }) => (scaleFactor ? `scale(${scaleFactor})` : 'none')};
  transform-origin: ${({ isMine }) => (isMine ? 'top right' : 'top left')};
  transition: ${({ maxHeight }) => (maxHeight ? 'all' : 'transform')} 0.25s ease-in-out;
`;
